import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBank = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		opacity: .5,
		clipPath: "url(#clip0_28_4819)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_28_4819)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M11.7385 2.67573C12.4748 2.23396 13.3946 2.23396 14.1309 2.67573L22.5592 7.73269C23.9072 8.5415 23.3338 10.6118 21.7617 10.6118H4.10771C2.53567 10.6118 1.96223 8.5415 3.31025 7.73269L11.7385 2.67573ZM4.10771 9.0618H21.7617L12.9347 3.7656L4.10771 9.0618Z",
					fill: "#360802"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M2.85742 21.4619H23.0074V23.0119H2.85742V21.4619Z",
					fill: "#360802"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7.50898 12.1621V19.9121H5.95898V12.1621H7.50898Z",
					fill: "#360802"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M11.6418 12.1621V19.9121H10.0918V12.1621H11.6418Z",
					fill: "#360802"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M15.7746 12.1621V19.9121H14.2246V12.1621H15.7746Z",
					fill: "#360802"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M19.9074 12.1621V19.9121H18.3574V12.1621H19.9074Z",
					fill: "#360802"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_28_4819",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24.8,
			height: 24.8,
			fill: "white",
			transform: "translate(0.533203 0.537109)"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_28_4819",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24.8,
			height: 24.8,
			fill: "white",
			transform: "translate(0.533203 0.537109)"
		})
	})] })]
});
export default SvgBank;
